import { render, staticRenderFns } from "./IssueAssetsModal.vue?vue&type=template&id=0ab91a8e&"
import script from "./IssueAssetsModal.vue?vue&type=script&lang=js&"
export * from "./IssueAssetsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports